


































































































































import Vue, { PropType } from 'vue';

interface Link {
  text: string;
  to?: string | Location;
  icon: 'contact' | 'brand' | 'booth' | 'item' | 'account' | 'dashboard' | 'visitors' | 'faq';
  isExternalSite?: boolean
}

interface DataType {
  isMenuActive: boolean;
}

export default Vue.extend({
  name: 'GSideNavigation',
  props: {
    topLinks: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
    mainLinks: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
    subLinks: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
  },
  data(): DataType {
    return {
      isMenuActive: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    handleResize() {
      if (window.innerWidth > 767 && this.isMenuActive) this.isMenuActive = false;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
});
